import { Button, Card } from 'react-bootstrap'
import React, { useState, useEffect } from "react";
import { Modal, Form as BsForm, Dropdown } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { addFile, createPromotion, deletePromotion, getPromotion, updatePromotion } from '../../services/Admin/adminServices';
import Pagination from '../components/Pagination';
import Spinner from '../components/Common/Spinner';
import toast from 'react-hot-toast';
import { debounce } from 'lodash';
const Promotion = () => {
  const [cards, setCards] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editCard, setEditCard] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Fetch cards from API
  const fetchCards = async () => {
    try {
      setLoading(true)
      const res = await getPromotion(currentPage, 10, debouncedSearch);
      setCards(res?.data?.data.promotions);
      setTotalItems(res?.data?.data.count);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards();
  }, [currentPage, debouncedSearch]);

  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500);

    handler();

    return () => {
      handler.cancel();
    };
  }, [search]);



  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>)





  // Delete card
  const handleDelete = async (id) => {
    try {
      await deletePromotion(id);
      setCards(cards.filter((card) => card._id !== id))
      toast.success('Promotion deleted successfully');
    } catch (error) {
      console.error("Error deleting card:", error);
    }
  };

  // Open modal for new or edit
  const handleOpenModal = (card = null) => {
    setEditCard(card);
    setShowModal(true);
    setPreviewFile(card?.media);
  };

  const handleCloseModal = () => {
    setEditCard(null);
    setShowModal(false);
  };

  // Validation schema
  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    url: Yup.string().url("Invalid image URL").required("Image URL is required"),
  });

  // Submit form (Add/Edit)
  const handleSubmit = async (values, { resetForm }) => {

    try {
      if (editCard) {
        // Edit existing card
        const res = await updatePromotion(values);
        fetchCards();
        toast.success('Promotion updated successfully');
      } else {
        const payload = { ...values };
        if (!editCard) delete payload.promotionId;
        const res = await createPromotion(payload);
        setPreviewFile(null);
        fetchCards()
      }
      resetForm();
      handleCloseModal();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error saving card");
      console.error("Error saving card:", error);
    }
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);




  return (



    <div>



      <h2 style={{ color: "#0AB7EA" }} className='fw-bold'>  Promotion</h2>




      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 mb-4">
        <div className="flex-grow-1">
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#0AB7EA" }}
            className="form-control w-100"
            placeholder="Search....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <Button
            style={{ background: "#0AB7EA", color: "white", marginBottom: "20px", border: 0 }}
            onClick={() => handleOpenModal()}
          >
            Add New
          </Button></div>
      </div>

















      <div className='row'>


        {loading ? (<Spinner />) : (

          cards?.map((img, index) => (
            <div className="col-md-3 mb-3 position-relative  " key={index}>
              <Card className="position-relative shadow-lg" style={{ backgroundColor: "#f8f9fa" }}>

                <Dropdown style={{ position: "absolute", top: "8px", right: "8px" }}>
                  <Dropdown.Toggle
                    variant="light"
                    id={`dropdown-basic-${index}`}
                    style={{ padding: "4px 8px" }}
                  >
                    {svg1}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleOpenModal(img)}>Edit</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDelete(img._id)}>Delete</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Card.Img variant="top" style={{ height: "200px", objectFit: "cover", width: "100%" }} src={img.media || img.url} />
                <div style={{ padding: "10px" }}>
                  <div className='fw-bold' style={{ color: "#0AB7EA", fontSize: "20px" }}>{img?.title}</div>
                  <div> {img.description}</div>
                </div>
              </Card>
            </div>
          ))

        )}


        <Modal show={showModal} onHide={handleCloseModal}>
          <Formik
            initialValues={{
              promotionId: editCard?._id || "",
              title: editCard?.title || "",
              description: editCard?.description || "",
              url: editCard?.url || "",
              media: editCard?.media || "",
              type: editCard?.type || "",
              isExternal: editCard?.isExternal || false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ isSubmitting, setFieldValue, values }) => (
              <Form> {/* ✅ Formik Form wrapper */}
                <Modal.Body>
                  {/* Title */}
                  <BsForm.Group className="mb-3">
                    <BsForm.Label>Title</BsForm.Label>
                    <Field className="form-control" type="text" name="title" />
                    <div style={{ color: "red" }}>
                      <ErrorMessage name="title" />
                    </div>
                  </BsForm.Group>

                  {/* Description */}
                  <BsForm.Group className="mb-3">
                    <BsForm.Label>Description</BsForm.Label>
                    <Field
                      className="form-control"
                      as="textarea"
                      rows={3}
                      name="description"
                    />
                    <div style={{ color: "red" }}>
                      <ErrorMessage name="description" />
                    </div>
                  </BsForm.Group>

                  {/* Image URL */}
                  <BsForm.Group className="mb-3">
                    <BsForm.Label>Image URL</BsForm.Label>
                    <Field className="form-control" type="text" name="url" />
                    <div style={{ color: "red" }}>
                      <ErrorMessage name="url" />
                    </div>
                  </BsForm.Group>

                  {/* Upload File */}
                  <BsForm.Group className="mb-3">
                    <BsForm.Label>Upload Image</BsForm.Label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={async (event) => {
                        const file = event.target.files[0];
                        if (file) {
                          const formData = new FormData();
                          formData.append("files", file);
                          try {
                            setUploading(true);
                            const res = await addFile(formData);
                            setUploading(false);

                            setPreviewFile(URL.createObjectURL(file));

                            if (res?.data?.data?.files) {
                              setFieldValue(
                                "media",
                                `https://api.socialjusticejamaica.com${res?.data?.data.files[0].path}`
                              );
                              setFieldValue("type", res?.data?.data.files[0].type);
                            }
                          } catch (error) {
                            console.error("Upload error:", error);
                          } finally {
                            event.target.value = "";
                          }
                        }
                      }}
                    />
                    {uploading && <p>Uploading...</p>}
                  </BsForm.Group>

                  {/* Preview */}
                  {previewFile && (
                    <div className="mb-3">
                      <img
                        src={previewFile}
                        alt="Preview"
                        style={{ width: "100%", height: "200px", objectFit: "cover" }}
                      />
                    </div>
                  )}



                  {/* External/Internal Selection */}
                  <BsForm.Group className="mb-3">
                    <BsForm.Label>Visibility</BsForm.Label>
                    <div>
                      <BsForm.Check
                        type="radio"
                        label="Outside App"
                        name="isExternal"
                        id="external"
                        checked={values.isExternal === true}
                        onChange={() => setFieldValue("isExternal", true)}
                        inline
                      />
                      <BsForm.Check
                        type="radio"
                        label="Inside App"
                        name="isExternal"
                        id="internal"
                        checked={values.isExternal === false}
                        onChange={() => setFieldValue("isExternal", false)}
                        inline
                      />
                    </div>
                  </BsForm.Group>






                </Modal.Body>

                {/* Footer */}
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    style={{ background: "#0AB7EA", color: "white", border: "none" }}
                    disabled={isSubmitting}
                  >
                    {editCard ? "Update" : "Add"}
                  </Button>
                </Modal.Footer>
              </Form>
            )}

          </Formik>
        </Modal>
      </div>








      <div className="card-footer clearfix">
        <div className="d-flex justify-content-between align-items-center">
          <div></div>
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px" }}
          >
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      </div>



    </div>
  )
}

export default Promotion